import React from "react";
import styled from "styled-components";

// components

import GalleryImage from "../components/molecules/GalleryImage";

// images

import one from "../assets/images/urban/one.jpg";
import two from "../assets/images/urban/two.jpg";
import three from "../assets/images/urban/three.jpg";
import four from "../assets/images/urban/four.jpg";
import five from "../assets/images/urban/five.jpg";
import six from "../assets/images/urban/six.jpg";
import seven from "../assets/images/urban/seven.jpg";
import eight from "../assets/images/urban/eight.jpg";
import nine from "../assets/images/urban/nine.jpg";
import ten from "../assets/images/urban/ten.jpg";
import eleven from "../assets/images/urban/eleven.jpg";
import twelve from "../assets/images/urban/twelve.jpg";
import thirteen from "../assets/images/urban/thirteen.jpg";
import fourteen from "../assets/images/urban/fourteen.jpg";
import fifteen from "../assets/images/urban/fifteen.jpg";
import sixteen from "../assets/images/urban/sixteen.jpg";
import seventeen from "../assets/images/urban/seventeen.jpg";
import eighteen from "../assets/images/urban/eighteen.jpg";
import nineteen from "../assets/images/urban/nineteen.jpg";
import twenty from "../assets/images/urban/twenty.jpg";

const urbanSet = [
  one,
  two,
  three,
  four,
  five,
  six,
  seven,
  eight,
  nine,
  ten,
  eleven,
  twelve,
  thirteen,
  fourteen,
  fifteen,
  sixteen,
  seventeen,
  eighteen,
  nineteen,
  twenty,
];

// style
const StyledUrbanScreen = styled.main`
  min-height: 88vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  h1 {
    opacity: 0.2;
    font-size: 3rem;
  }
  section {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  // 720
  @media screen and (min-width: 1366px) {
    section {
      max-width: 75vw;
    }
  }
`;

const LoginScreen = () => {
  return (
    <StyledUrbanScreen>
      <h1>Urban </h1>
      <section>
        {urbanSet.map((image) => (
          <GalleryImage bgImage={image} />
        ))}
      </section>
    </StyledUrbanScreen>
  );
};

export default LoginScreen;
